var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFailedAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 12C9.81371 12 12.5 9.31371 12.5 6C12.5 2.68629 9.81371 0 6.5 0C3.18629 0 0.5 2.68629 0.5 6C0.5 9.31371 3.18629 12 6.5 12ZM6.5 2.67857C6.85504 2.67857 7.14286 2.96639 7.14286 3.32143V6.10714C7.14286 6.46218 6.85504 6.75 6.5 6.75C6.14496 6.75 5.85714 6.46218 5.85714 6.10714V3.32143C5.85714 2.96639 6.14496 2.67857 6.5 2.67857ZM7.35714 8.46429C7.35714 8.93769 6.97338 9.32143 6.5 9.32143C6.02662 9.32143 5.64286 8.93769 5.64286 8.46429C5.64286 7.9909 6.02662 7.60714 6.5 7.60714C6.97338 7.60714 7.35714 7.9909 7.35714 8.46429Z",
    fill: "#DA2F58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailedAlert);
export default __webpack_public_path__ + "static/media/failed-alert.1f26e30e3cb44acd2aabf9d091d40a95.svg";
export { ForwardRef as ReactComponent };